module.exports = __webpack_public_path__ + "static/media/problem_solving.27ae3eb4.svg";